module.exports = __webpack_public_path__ + "img/bg2.144591e7.png";